"use strict";

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.symbol.description.js");

var _react = _interopRequireDefault(require("react"));

var _typography = _interopRequireDefault(require("~data/typography"));

var styles = _interopRequireWildcard(require("./styles.module.scss"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}
/** ============================================================================
 * Slice
 */


var TypeTable = function TypeTable(_ref) {
  var id = _ref.id,
      className = _ref.className,
      _ref$data = _ref.data,
      backgroundColor = _ref$data.backgroundColor,
      fontColor = _ref$data.fontColor,
      padded = _ref$data.padded,
      dockedTop = _ref$data.dockedTop,
      dockedBottom = _ref$data.dockedBottom,
      _ref$data$subheadingS = _ref$data.subheadingStyle,
      subheadingStyle = _ref$data$subheadingS === void 0 ? "b2" : _ref$data$subheadingS;
  return /*#__PURE__*/_react.default.createElement("section", {
    sliceid: id,
    className: [className, styles.container, dockedTop ? styles.dockedTop : "", dockedBottom ? styles.dockedBottom : "", padded ? styles.padded : ""].join(" "),
    style: {
      background: (backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.hex) || "white",
      color: (fontColor === null || fontColor === void 0 ? void 0 : fontColor.hex) || "white"
    }
  }, _typography.default.map(function (_ref2) {
    var min = _ref2.min,
        max = _ref2.max,
        breakpointStyles = _ref2.styles;
    return /*#__PURE__*/_react.default.createElement("ul", {
      key: "type-table-".concat(min, "-").concat(max),
      className: styles.list
    }, /*#__PURE__*/_react.default.createElement("li", {
      className: styles.listHeading
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: [styles.listHeadingStyle, subheadingStyle].join(" ")
    }, min, "-", max === -1 ? "1920px+" : "".concat(max, "px"), " Styles"), /*#__PURE__*/_react.default.createElement("p", {
      className: [styles.listHeadingSize, subheadingStyle].join(" ")
    }, "Font-size"), /*#__PURE__*/_react.default.createElement("p", {
      className: [styles.listHeadingHeight, subheadingStyle].join(" ")
    }, "Line-height"), /*#__PURE__*/_react.default.createElement("p", {
      className: [styles.listHeadingSpacing, subheadingStyle].join(" ")
    }, "Letter-spacing")), breakpointStyles.map(function (_ref3) {
      var styleId = _ref3.id,
          className = _ref3.className,
          attributes = _ref3.attributes;
      return /*#__PURE__*/_react.default.createElement("li", {
        key: "type-table-row-".concat(styleId),
        className: styles.listItem
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: [styles.listItemStyle, className].join(" "),
        style: _objectSpread({}, attributes)
      }, styleId), /*#__PURE__*/_react.default.createElement("p", {
        className: [styles.listItemSize, subheadingStyle].join(" ")
      }, attributes.fontSize), /*#__PURE__*/_react.default.createElement("p", {
        className: [styles.listItemHeight, subheadingStyle].join(" ")
      }, attributes.lineHeight), /*#__PURE__*/_react.default.createElement("p", {
        className: [styles.listItemSpacing, subheadingStyle].join(" ")
      }, attributes.letterSpacing));
    }));
  }));
};

var _default = TypeTable;
exports.default = _default;